import { normaliseInviteCode } from "@luckymenu/core";
import { useTranslation } from "@luckymenu/i18n/react";
import { Button, Input, Label } from "@luckymenu/ui-web";
import { useNavigate } from "@tanstack/react-router";
import { type FormEvent, useId, useState } from "react";

/** Typing an invite code: goes to the join page for it. */
export function JoinCodeForm({ initial = "" }: { initial?: string }) {
	const { t } = useTranslation("staff");
	const navigate = useNavigate();
	const id = useId();
	const [code, setCode] = useState(initial);
	const [invalid, setInvalid] = useState(false);

	const submit = (event: FormEvent) => {
		event.preventDefault();
		const normalised = normaliseInviteCode(code);
		if (!normalised) {
			setInvalid(true);
			return;
		}
		void navigate({ to: "/join/$code", params: { code: normalised } });
	};

	return (
		<form onSubmit={submit} className="grid gap-2" noValidate>
			<Label htmlFor={id}>{t("join.codeLabel")}</Label>
			<Input
				id={id}
				value={code}
				onChange={(e) => {
					setInvalid(false);
					setCode(e.target.value);
				}}
				placeholder={t("join.codePlaceholder")}
				autoComplete="off"
				autoCapitalize="characters"
				spellCheck={false}
				className="font-mono tracking-widest uppercase"
				aria-invalid={invalid || undefined}
				aria-describedby={`${id}-hint`}
			/>
			<p
				id={`${id}-hint`}
				className={invalid ? "text-sm text-destructive" : "text-xs text-muted-foreground"}
			>
				{invalid ? t("join.problems.invalid") : t("join.codeHint")}
			</p>
			<Button type="submit" size="lg" className="w-full">
				{t("join.continue")}
			</Button>
		</form>
	);
}
